export default {
	generateUID (config) {
		const def = {
			prefix: 'guid',
			length: 8,
			...config && config.generateUID || {}
		}

		return (prefix = def.prefix, length = def.length) => {
			return prefix + Math.random().toString(36).substr(2, length);
		};
	}
};
